module.exports = __webpack_public_path__ + "img/cmp_di.10bf4d1e.png";